import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import DialogActions from "@mui/material/DialogActions";

import ModalBasicLayout from "../ModalBasicLayout";
import ContainerModalActions from "../../Containers/ContainerModalActions";
import CompetitorsEditor from "../../BusinessCompetitors/CompetitorsEditor";
import { useTranslationApp } from "../../../lib/i18next";
import { MAX_BUSINESS_COMPETITORS } from "../../../utils/constants";
import {
  BUTTON_CANCEL,
  BUTTON_SAVE,
  MODAL_COMPETITORS_EDIT_COUNT_ARIA,
  MODAL_COMPETITORS_EDIT_SUBTITLE,
  MODAL_COMPETITORS_EDIT_TITLE,
} from "../../../i18n/keysTranslations";
import useModalCompetitorsEditor from "./useModalCompetitorsEditor";

const ModalCompetitorsEdit = ({
  modalOpen,
  onCloseModal,
  businessCompetitors,
  dispatch,
  onSaved,
}) => {
  const { t } = useTranslationApp();
  const {
    control,
    errors,
    watch,
    setValue,
    businessCompetitorsFields,
    appendBusinessCompetitors,
    removeBusinessCompetitors,
    validationRules,
    onSaveCompetitors,
    onCancelEdit,
  } = useModalCompetitorsEditor({
    businessCompetitors,
    dispatch,
    modalOpen,
    onSaved,
    onCloseModal,
  });

  const currentCompetitors = watch("businessCompetitors") || [];
  const competitorCount = currentCompetitors.length;

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCancelEdit}
      maxWidth="sm"
      fullWidth={true}
      scroll="paper"
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 2,
              mb: 0.5,
            }}
          >
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              {t(MODAL_COMPETITORS_EDIT_TITLE)}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
                fontWeight: 500,
                flexShrink: 0,
                mr: 1.2,
              }}
              aria-label={t(MODAL_COMPETITORS_EDIT_COUNT_ARIA, {
                current: competitorCount,
                max: MAX_BUSINESS_COMPETITORS,
              })}
            >
              {competitorCount}/{MAX_BUSINESS_COMPETITORS}
            </Typography>
          </Box>
          <Typography variant="body1" sx={{ color: "text.secondary" }}>
            {t(MODAL_COMPETITORS_EDIT_SUBTITLE)}
          </Typography>
        </Box>

        <CompetitorsEditor
          control={control}
          errors={errors}
          watch={watch}
          setValue={setValue}
          businessCompetitorsFields={businessCompetitorsFields}
          appendBusinessCompetitors={appendBusinessCompetitors}
          removeBusinessCompetitors={removeBusinessCompetitors}
          validationRules={validationRules}
        />
      </Box>

      <DialogActions sx={{ px: 0, pt: 2, pb: 0 }}>
        <ContainerModalActions
          hasPadding={true}
          propsSecondaryButton={{
            showButton: true,
            onClick: onCancelEdit,
            text: BUTTON_CANCEL,
          }}
          propsPrimaryButton={{
            showButton: true,
            onClick: onSaveCompetitors,
            text: BUTTON_SAVE,
            type: "button",
          }}
        />
      </DialogActions>
    </ModalBasicLayout>
  );
};

export default ModalCompetitorsEdit;
